<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'CreateRetailerCategory',
  data() {
    return {
      progress: false,
      form: {
        name: '',
        providerId: '',
      },
      rules: {
        providerId: {
          required: true,
          message: 'Provider is required',
        },
        name: [
          {
            required: true,
            message: 'Name field is required',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('providers', [
      'providers',
    ]),
    ...mapGetters('me', ['isSuperAdmin']),
  },
  methods: {
    ...mapActions('category', ['createCategory']),
    async onSubmit() {
      const { form } = this
      const formValid = await this.$refs.form.validate().catch(() => false)

      if (!formValid) {
        return
      }

      this.progress = true

      const options = { headers: { 'x-provider-id': form.providerId } }
      const response = await this.createCategory({
        form,
        options,
      })

      this.$notifier({
        response,
        successMsg: 'Category was successfully created',
      }).then(success => {
        if (success) {
          this.$emit('added', success)
          this.$modal.self.hide()
        }
      })

      this.progress = false
    },
  },
}
</script>

<template>
  <base-modal
    title="Add new Category"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-form-item
        label="Category Name"
        prop="name"
      >
        <el-input
          v-model="form.name"
          placeholder="Category name"
        />
      </el-form-item>

      <el-form-item
        label="Provider Name"
        :prop="isSuperAdmin ? 'providerId': ''"
      >
        <el-select
          v-model="form.providerId"
          placeholder="Select provider"
        >
          <el-option
            v-for="provider in providers"
            :key="provider.id"
            :label="provider.name"
            :value="provider.id"
          />
        </el-select>
      </el-form-item>

      <el-button
        type="primary"
        :class="$style.button"
        :loading="progress"
        class="el-button--wide"
        @click.stop="onSubmit"
      >
        Save
      </el-button>
    </el-form>
  </base-modal>
</template>

<style lang="scss" module>
.button {
  display: block;
  // width: 60%;
  margin: 2rem auto 0;
}
</style>
